module.exports = __webpack_public_path__ + "img/ShelterLogo200x195.d4e56b27.jpg";